import React from 'react';
import { BaasicModal, YesNoView } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
	},
};

function BaasicWarningModalTemplate({ modalParams, t }) {
	return (
		<BaasicModal modalParams={modalParams} style={customStyles}>
			<YesNoView
				message={modalParams.message}
				onConfirm={modalParams.onConfirm}
				onCancel={modalParams.onCancel}
				yesLabel={t('CONTINUE')}
				noLabel={t('CANCEL')}
			/>
		</BaasicModal>
	);
}

export default defaultTemplate(BaasicWarningModalTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/dialog/BaasicWarningModalTemplate.jsx